var map = {
	"./statusCorrectStatic.png": "725b",
	"./statusCorrectStaticChester.png": "ef5a",
	"./statusCorrectStaticDusty.png": "f39e",
	"./statusCorrectStaticLisa.png": "5f5e",
	"./statusCorrectStaticPoppy.png": "cdef",
	"./statusCorrectStaticTom.png": "0fa4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "640a";